import { userInfoSync } from 'hub-http/userInfo';
export const hasScope = scope => {
  try {
    const {
      user
    } = userInfoSync();
    return user.scopes.includes(scope);
  } catch (err) {
    return false;
  }
};